import type {
	FieldConfig,
	OperationOption,
	UseOptionsQuery,
	ValueState,
} from '../../types'

import { Operators } from '../../constants'
import { stringToArray } from '../../utils/utils'
import FieldController from '../Controller'

type Options = {
	value: string
	label: string
}[]
export default class StringController extends FieldController {
	constructor(config: FieldConfig) {
		super(config)
		this.note = config.note
		this.validate = config.validate || this.defaultValidate
		this.useSelectOptions = config.useSelectOptions || this.useSelectOptions
		this.getFilterTypes = config.getFilterTypes || this.getFilterTypes
		this.getInitialValue = config.getInitialValue || this.getInitialValue
	}
	hasValue = ({ operation, value }: ValueState) => {
		if ([Operators.IS_EMPTY, Operators.IS_NOT_EMPTY].includes(operation)) {
			return true
		}

		return Boolean(typeof value === 'string' && value.length)
	}
	useSelectOptions(): UseOptionsQuery<Options> {
		return {
			data: [],
		}
	}
	getInitialValue = () => ({
		operation: Operators.CONTAINS,
		value: '',
	})

	getFilterTypes = (): OperationOption[] => [
		{
			operation: Operators.CONTAINS,
			label: 'contains',
			hasInput: true,
		},
		{
			operation: Operators.NOT_CONTAINS,
			label: 'does not contain',
			hasInput: true,
		},
		{
			operation: Operators.IS_NOT,
			label: 'is not',
			hasInput: true,
		},
		{
			operation: Operators.IS,
			label: 'is',
			hasInput: true,
		},
		{
			operation: Operators.IN,
			label: 'in',
			hasInput: true,
		},
		{
			operation: Operators.NOT_IN,
			label: 'not in',
			hasInput: true,
		},
		{
			operation: Operators.IS_EMPTY,
			label: 'is empty',
		},
		{
			operation: Operators.IS_NOT_EMPTY,
			label: 'is not empty',
		},
	]

	defaultValidate = ({ operation, value }: ValueState) => {
		if ([Operators.IS_EMPTY, Operators.IS_NOT_EMPTY].includes(operation)) {
			return null
		}
		if (!value || !value.length) {
			return 'Please provide some text.'
		}

		return null
	}
	formatState = ({ operation, value }: ValueState, options?: Options) => {
		if ([Operators.IS_EMPTY, Operators.IS_NOT_EMPTY].includes(operation)) {
			return {
				operation,
				value: '',
			}
		}
		if ([Operators.IN, Operators.NOT_IN].includes(operation)) {
			const _value = stringToArray(value || '')
			const selectedOptions = _value?.map(
				(value) =>
					options?.find((o) => value === o.value) || { value, label: value }
			)

			return {
				operation,
				value: selectedOptions.map((o) => o.label).join(', '),
			}
		}

		return {
			operation,
			value: stringToArray(value || '').join(', '),
		}
	}
}
